import script from "./ViewPinia.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPinia.vue?vue&type=script&setup=true&lang=js"

import "./ViewPinia.vue?vue&type=style&index=0&id=79dc39c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79dc39c4"]])

export default __exports__